export const tryGetTargetMessages = <T>(
  localesWithMessages: Record<string, T | null>,
  languageLocale: string,
) => {
  const messagesLanguage = languageLocale.replace(/-/g, '_');
  return localesWithMessages[messagesLanguage];
};

/* utility function that is helpful to return properly-typed locale messages from ES6 module */
export const getTargetMessages = <T>(
  localesWithMessages: Record<string, T | null>,
  languageLocale: string,
) => {
  const localeMessages = tryGetTargetMessages(localesWithMessages, languageLocale);
  if (localeMessages) return localeMessages;
  throw new Error('Unsupported target language locale provided');
};
